import React from "react";
import Step1 from "../steps/section-3/step-1";
import Step2 from "../steps/section-3/step-2";
import Step3 from "../steps/section-3/step-3";
import Step4 from "../steps/section-3/step-4";

function TeamReportsSection3({
  step = 1,
  expectedNetProfits = 0,
  actualNetProfits = 0,
  netRevenues = 0,
  netProfits = 0,
  actual = {},
  expected = {},
  current_year = 0,
  incomeStatement
}) {
  if (step === 1) {
    return <Step1 />;
  }

  if (step === 2) {
    return (
      <Step2 actual={actual} expected={expected} current_year={current_year} />
    );
  }

  if (step === 3) {
    return (
      <Step3
        expectedNetProfits={expectedNetProfits}
        actualNetProfits={actualNetProfits}
        actual={actual}
        expected={expected}
        current_year={current_year}
      />
    );
  }

  if (step === 4) {
    return (
      <Step4
        netRevenues={netRevenues}
        netProfits={netProfits}
        incomeStatement={incomeStatement}
        current_year={current_year}
      />
    );
  }

  return null;
}

export default TeamReportsSection3;



// WEBPACK FOOTER //
// ./src/components/team-reports/sections/section-3.js